import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../infra/http/axios-http-client";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY } from "../../base";
import { RemoteFetchBrands } from "../../data/usecases/remote-fetch-brands";
import Endpoints from "../../domain/endpoints";
import { Speciality } from "../../domain/models/speciality";
import { getDataKeyFromLocalStorage } from "../../common/utils/AuthToken";

export interface BrandDataInterface {
  fetchBrandsData: Function;
  brandData: Speciality[];
}

const initialStates = {
  brandData: [],
};

export const useFetchBrandSlice: StateCreator<BrandDataInterface> = (
  set,
) => ({
  ...initialStates,
  fetchBrandsData: async (department_id: string) => {
    const axiosHttpClient = AxiosHttpClient.getInstance();


   const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
   const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });
    const remoteFetchBrandsMaster = new RemoteFetchBrands(
      `${BASE_URL}${Endpoints.FETCH_BRANDS}`,
      axiosHttpClient
    );
    let params = {
      department_id : department_id,
    }

    let result = await remoteFetchBrandsMaster.fetch(params);
    if (result) {
      set(() => ({ brandData: result.brands }));
    }
  },
});
